import _defineProperty from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _classCallCheck from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import $fzaAv$react from "react";

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
var $eb2240fc39a57fa5$export$bf788dd355e3a401 = /*#__PURE__*/function () {
  _createClass($eb2240fc39a57fa5$export$bf788dd355e3a401, [{
    key: "build",
    value: function build(props, context) {
      var _this = this;
      this.context = context;
      return $eb2240fc39a57fa5$var$iterable(function () {
        return _this.iterateCollection(props);
      });
    }
  }, {
    key: "iterateCollection",
    value: /*#__PURE__*/_regeneratorRuntime().mark(function iterateCollection(props) {
      var children, items, _iterator, _step, item, _items, index, _i, _items2, _item, nodes, _iterator2, _step2, node;
      return _regeneratorRuntime().wrap(function iterateCollection$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            children = props.children, items = props.items;
            if (!(typeof children === 'function')) {
              _context.next = 22;
              break;
            }
            if (items) {
              _context.next = 4;
              break;
            }
            throw new Error('props.children was a function but props.items is missing');
          case 4:
            _iterator = _createForOfIteratorHelper(props.items);
            _context.prev = 5;
            _iterator.s();
          case 7:
            if ((_step = _iterator.n()).done) {
              _context.next = 12;
              break;
            }
            item = _step.value;
            return _context.delegateYield(this.getFullNode({
              value: item
            }, {
              renderer: children
            }), "t0", 10);
          case 10:
            _context.next = 7;
            break;
          case 12:
            _context.next = 17;
            break;
          case 14:
            _context.prev = 14;
            _context.t1 = _context["catch"](5);
            _iterator.e(_context.t1);
          case 17:
            _context.prev = 17;
            _iterator.f();
            return _context.finish(17);
          case 20:
            _context.next = 50;
            break;
          case 22:
            _items = [];
            (0, $fzaAv$react).Children.forEach(children, function (child) {
              _items.push(child);
            });
            index = 0;
            _i = 0, _items2 = _items;
          case 26:
            if (!(_i < _items2.length)) {
              _context.next = 50;
              break;
            }
            _item = _items2[_i];
            nodes = this.getFullNode({
              element: _item,
              index: index
            }, {});
            _iterator2 = _createForOfIteratorHelper(nodes);
            _context.prev = 30;
            _iterator2.s();
          case 32:
            if ((_step2 = _iterator2.n()).done) {
              _context.next = 39;
              break;
            }
            node = _step2.value;
            index++;
            _context.next = 37;
            return node;
          case 37:
            _context.next = 32;
            break;
          case 39:
            _context.next = 44;
            break;
          case 41:
            _context.prev = 41;
            _context.t2 = _context["catch"](30);
            _iterator2.e(_context.t2);
          case 44:
            _context.prev = 44;
            _iterator2.f();
            return _context.finish(44);
          case 47:
            _i++;
            _context.next = 26;
            break;
          case 50:
          case "end":
            return _context.stop();
        }
      }, iterateCollection, this, [[5, 14, 17, 20], [30, 41, 44, 47]]);
    })
  }, {
    key: "getKey",
    value: function getKey(item, partialNode, state, parentKey) {
      if (item.key != null) return item.key;
      if (partialNode.type === 'cell' && partialNode.key != null) return "".concat(parentKey).concat(partialNode.key);
      var v = partialNode.value;
      if (v != null) {
        var _v_key;
        var key = (_v_key = v.key) !== null && _v_key !== void 0 ? _v_key : v.id;
        if (key == null) throw new Error('No key found for item');
        return key;
      }
      return parentKey ? "".concat(parentKey, ".").concat(partialNode.index) : "$.".concat(partialNode.index);
    }
  }, {
    key: "getChildState",
    value: function getChildState(state, partialNode) {
      return {
        renderer: partialNode.renderer || state.renderer
      };
    }
  }, {
    key: "getFullNode",
    value: /*#__PURE__*/_regeneratorRuntime().mark(function getFullNode(partialNode, state, parentKey, parentNode) {
      var element, cached, type, name, childNodes, index, result, childNode, nodeKey, nodes, children, _iterator3, _step3, _node, builder, node;
      return _regeneratorRuntime().wrap(function getFullNode$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            // If there's a value instead of an element on the node, and a parent renderer function is available,
            // use it to render an element for the value.
            element = partialNode.element;
            if (!(!element && partialNode.value && state && state.renderer)) {
              _context3.next = 10;
              break;
            }
            cached = this.cache.get(partialNode.value);
            if (!(cached && (!cached.shouldInvalidate || !cached.shouldInvalidate(this.context)))) {
              _context3.next = 9;
              break;
            }
            cached.index = partialNode.index;
            cached.parentKey = parentNode ? parentNode.key : null;
            _context3.next = 8;
            return cached;
          case 8:
            return _context3.abrupt("return");
          case 9:
            element = state.renderer(partialNode.value);
          case 10:
            if (!(0, $fzaAv$react).isValidElement(element)) {
              _context3.next = 51;
              break;
            }
            type = element.type;
            if (!(typeof type !== 'function' && typeof type.getCollectionNode !== 'function')) {
              _context3.next = 15;
              break;
            }
            name = typeof element.type === 'function' ? element.type.name : element.type;
            throw new Error("Unknown element <".concat(name, "> in collection."));
          case 15:
            childNodes = type.getCollectionNode(element.props, this.context);
            index = partialNode.index;
            result = childNodes.next();
          case 18:
            if (!(!result.done && result.value)) {
              _context3.next = 50;
              break;
            }
            childNode = result.value;
            partialNode.index = index;
            nodeKey = childNode.key;
            if (!nodeKey) nodeKey = childNode.element ? null : this.getKey(element, partialNode, state, parentKey);
            nodes = this.getFullNode(_objectSpread({}, childNode, {
              key: nodeKey,
              index: index,
              wrapper: $eb2240fc39a57fa5$var$compose(partialNode.wrapper, childNode.wrapper)
            }), this.getChildState(state, childNode), parentKey ? "".concat(parentKey).concat(element.key) : element.key, parentNode);
            children = _toConsumableArray(nodes);
            _iterator3 = _createForOfIteratorHelper(children);
            _context3.prev = 26;
            _iterator3.s();
          case 28:
            if ((_step3 = _iterator3.n()).done) {
              _context3.next = 39;
              break;
            }
            _node = _step3.value;
            // Cache the node based on its value
            _node.value = childNode.value || partialNode.value;
            if (_node.value) this.cache.set(_node.value, _node);
            // The partial node may have specified a type for the child in order to specify a constraint.
            // Verify that the full node that was built recursively matches this type.
            if (!(partialNode.type && _node.type !== partialNode.type)) {
              _context3.next = 34;
              break;
            }
            throw new Error("Unsupported type <".concat($eb2240fc39a57fa5$var$capitalize(_node.type), "> in <").concat($eb2240fc39a57fa5$var$capitalize(parentNode.type), ">. Only <").concat($eb2240fc39a57fa5$var$capitalize(partialNode.type), "> is supported."));
          case 34:
            index++;
            _context3.next = 37;
            return _node;
          case 37:
            _context3.next = 28;
            break;
          case 39:
            _context3.next = 44;
            break;
          case 41:
            _context3.prev = 41;
            _context3.t0 = _context3["catch"](26);
            _iterator3.e(_context3.t0);
          case 44:
            _context3.prev = 44;
            _iterator3.f();
            return _context3.finish(44);
          case 47:
            result = childNodes.next(children);
            _context3.next = 18;
            break;
          case 50:
            return _context3.abrupt("return");
          case 51:
            if (!(partialNode.key == null)) {
              _context3.next = 53;
              break;
            }
            return _context3.abrupt("return");
          case 53:
            // Create full node
            builder = this;
            node = {
              type: partialNode.type,
              props: partialNode.props,
              key: partialNode.key,
              parentKey: parentNode ? parentNode.key : null,
              value: partialNode.value,
              level: parentNode ? parentNode.level + 1 : 0,
              index: partialNode.index,
              rendered: partialNode.rendered,
              textValue: partialNode.textValue,
              'aria-label': partialNode['aria-label'],
              wrapper: partialNode.wrapper,
              shouldInvalidate: partialNode.shouldInvalidate,
              hasChildNodes: partialNode.hasChildNodes,
              childNodes: $eb2240fc39a57fa5$var$iterable(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
                var index, _iterator4, _step4, child, _nodes, _iterator5, _step5, _node2;
                return _regeneratorRuntime().wrap(function _callee$(_context2) {
                  while (1) switch (_context2.prev = _context2.next) {
                    case 0:
                      if (partialNode.hasChildNodes) {
                        _context2.next = 2;
                        break;
                      }
                      return _context2.abrupt("return");
                    case 2:
                      index = 0;
                      _iterator4 = _createForOfIteratorHelper(partialNode.childNodes());
                      _context2.prev = 4;
                      _iterator4.s();
                    case 6:
                      if ((_step4 = _iterator4.n()).done) {
                        _context2.next = 31;
                        break;
                      }
                      child = _step4.value;
                      // Ensure child keys are globally unique by prepending the parent node's key
                      if (child.key != null)
                        // TODO: Remove this line entirely and enforce that users always provide unique keys.
                        // Currently this line will have issues when a parent has a key `a` and a child with key `bc`
                        // but another parent has key `ab` and its child has a key `c`. The combined keys would result in both
                        // children having a key of `abc`.
                        child.key = "".concat(node.key).concat(child.key);
                      child.index = index;
                      _nodes = builder.getFullNode(child, builder.getChildState(state, child), node.key, node);
                      _iterator5 = _createForOfIteratorHelper(_nodes);
                      _context2.prev = 12;
                      _iterator5.s();
                    case 14:
                      if ((_step5 = _iterator5.n()).done) {
                        _context2.next = 21;
                        break;
                      }
                      _node2 = _step5.value;
                      index++;
                      _context2.next = 19;
                      return _node2;
                    case 19:
                      _context2.next = 14;
                      break;
                    case 21:
                      _context2.next = 26;
                      break;
                    case 23:
                      _context2.prev = 23;
                      _context2.t0 = _context2["catch"](12);
                      _iterator5.e(_context2.t0);
                    case 26:
                      _context2.prev = 26;
                      _iterator5.f();
                      return _context2.finish(26);
                    case 29:
                      _context2.next = 6;
                      break;
                    case 31:
                      _context2.next = 36;
                      break;
                    case 33:
                      _context2.prev = 33;
                      _context2.t1 = _context2["catch"](4);
                      _iterator4.e(_context2.t1);
                    case 36:
                      _context2.prev = 36;
                      _iterator4.f();
                      return _context2.finish(36);
                    case 39:
                    case "end":
                      return _context2.stop();
                  }
                }, _callee, null, [[4, 33, 36, 39], [12, 23, 26, 29]]);
              }))
            };
            _context3.next = 57;
            return node;
          case 57:
          case "end":
            return _context3.stop();
        }
      }, getFullNode, this, [[26, 41, 44, 47]]);
    })
  }]);
  function $eb2240fc39a57fa5$export$bf788dd355e3a401() {
    _classCallCheck(this, $eb2240fc39a57fa5$export$bf788dd355e3a401);
    this.cache = new WeakMap();
  }
  return $eb2240fc39a57fa5$export$bf788dd355e3a401;
}(); // Wraps an iterator function as an iterable object, and caches the results.
function $eb2240fc39a57fa5$var$iterable(iterator) {
  var cache = [];
  var iterable = null;
  return _defineProperty({}, Symbol.iterator, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var _i2, _cache, item, _iterator6, _step6, _item2;
    return _regeneratorRuntime().wrap(function _callee2$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _i2 = 0, _cache = cache;
        case 1:
          if (!(_i2 < _cache.length)) {
            _context4.next = 8;
            break;
          }
          item = _cache[_i2];
          _context4.next = 5;
          return item;
        case 5:
          _i2++;
          _context4.next = 1;
          break;
        case 8:
          if (!iterable) iterable = iterator();
          _iterator6 = _createForOfIteratorHelper(iterable);
          _context4.prev = 10;
          _iterator6.s();
        case 12:
          if ((_step6 = _iterator6.n()).done) {
            _context4.next = 19;
            break;
          }
          _item2 = _step6.value;
          cache.push(_item2);
          _context4.next = 17;
          return _item2;
        case 17:
          _context4.next = 12;
          break;
        case 19:
          _context4.next = 24;
          break;
        case 21:
          _context4.prev = 21;
          _context4.t0 = _context4["catch"](10);
          _iterator6.e(_context4.t0);
        case 24:
          _context4.prev = 24;
          _iterator6.f();
          return _context4.finish(24);
        case 27:
        case "end":
          return _context4.stop();
      }
    }, _callee2, null, [[10, 21, 24, 27]]);
  }));
}
function $eb2240fc39a57fa5$var$compose(outer, inner) {
  if (outer && inner) return function (element) {
    return outer(inner(element));
  };
  if (outer) return outer;
  if (inner) return inner;
}
function $eb2240fc39a57fa5$var$capitalize(str) {
  return str[0].toUpperCase() + str.slice(1);
}
export { $eb2240fc39a57fa5$export$bf788dd355e3a401 as CollectionBuilder };